class KidsSignup extends HTMLElement {
  constructor() {
    super();
    this.listId = this.dataset.listId;
    this.companyId = this.dataset.companyId;
  }

  connectedCallback() {
    this.submitButton = this.querySelector("button[type='submit']");
    this.form = this.querySelector("form");
    this.email = this.querySelector("input[type='email']");
    this.error = this.querySelector(".error");
    this.success = this.querySelector(".success");

    if (this.error) this.error.style.display = "none";
    if (this.success) this.success.style.display = "none";

    if (this.form) {
      this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
    }
  }

  showError(errorText) {
    this.error.style.display = "block";
    this.error.innerHTML = errorText;
    this.resetButton();
  }

  resetButton() {
    this.submitButton.innerHTML =
      this.submitButton.dataset.originalText || "Submit";
    this.submitButton.disabled = false;
  }

  resetForm() {
    this.form.reset();
    this.error.style.display = "none";
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    if (!this.email.value || !this.email.value.includes("@")) {
      this.showError("Please enter a valid email address");
      return;
    }

    this.submitButton.dataset.originalText = this.submitButton.innerHTML;
    this.submitButton.innerHTML = "Submitting...";
    this.submitButton.disabled = true;

    this.error.style.display = "none";
    this.success.style.display = "none";

    try {
      await this.createProfile();
      await this.addToList();

      this.success.style.display = "block";
      this.resetButton();
      setTimeout(() => this.resetForm(), 3000);
    } catch (error) {
      this.showError(error.message);
    }
  }

  async createProfile() {
    const endpoint = "https://a.klaviyo.com/client/profiles";
    const headers = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      revision: "2025-01-15",
    };
    const payload = {
      data: {
        type: "profile",
        attributes: {
          company_id: "YtTm4E",
          email: this.email.value,
        },
      },
    };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.errors?.[0]?.detail ||
            "An error occurred while creating your profile, please try again."
        );
      }

      console.log("Profile created successfully.");
      return data;
    } catch (error) {
      console.error("Profile creation error:", error);
      throw error;
    }
  }

  async addToList() {
    const baseEndpoint = "https://a.klaviyo.com/client/subscriptions";
    const endpoint = `${baseEndpoint}?company_id=${this.companyId}`;

    const headers = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      revision: "2025-01-15",
    };
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: this.email.value,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: this.listId,
            },
          },
        },
      },
    };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.errors?.[0]?.detail ||
            "Profile created, but failed to add to list."
        );
      }

      console.log("Added to list successfully.");
      return data;
    } catch (error) {
      console.error("List subscription error:", error);
      throw error;
    }
  }
}

customElements.define("kids-signup", KidsSignup);
